module.exports = __webpack_public_path__ + "img/generator_darkmode.d929c97b.png";